export class SavingsPotsEntity {
  constructor() {
    this.id = null;
    this.pots = null;
    this.unAllocatedData = null;
  }
  getPotList() {
    return this.pots;
  }
  unAllocatedAmount() {
    return this.unAllocatedData;
  }
}
export default SavingsPotsEntity;
